<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span class="pr-2 mr-2 font-bold text-2xl">Data Batch</span>
      <div>
        <i class="pi pi-home mr-2"></i>
        <span class="font-small">/ Master / Obat / Data Batch</span>
      </div>
    </div>
    <div class="card bg-white">
      <div class="flex justify-content-end mb-2">
        <Button
          :loading="isLoadingExport"
          icon="pi pi-file-excel"
          label="Export"
          class="p-button-outlined"
          @click="onExport"
        />
      </div>
      <grid-obat-batch
        :items="items"
        :loading="isLoading"
        :total="totalRecords"
        :grid-options="options"
        @request="onRequestData"
      />
    </div>
  </div>
</template>

<script>
import ObatService from '@/services/ObatService'
import GridObatBatch from '@/components/master/GridObatBatch'
import errorHandler from '@/helpers/error-handler'

export default {
  name: 'ObatBatch',
  components: {
    GridObatBatch,
  },
  data() {
    return {
      obatService: null,
      isLoading: false,
      isLoadingExport: false,
      items: [],
      totalRecords: 0,
      options: {
        page: 1,
        rows: 10,
        sortField: null,
        sortOrder: null,
        filters: null,
      },
    }
  },
  created() {
    this.obatService = new ObatService()
  },
  mounted() {
    this.loadGridData()
  },
  methods: {
    onRequestData(e) {
      this.options = e
      this.loadGridData()
    },
    loadGridData() {
      const page = this.options.page
      const perPage = this.options.rows
      const sortField = this.options.sortField
      const sortOrder = this.options.sortOrder
      const filters = this.options.filters

      this.isLoading = true
      this.obatService
        .paginateBatch(page, perPage, sortField, sortOrder, filters)
        .then((res) => {
          this.items = res.data.data
          this.totalRecords = res.data.total
          this.isLoading = false
        })
        .catch((err) => {
          errorHandler(err, 'Data Batch', this)
        })
        .finally(() => (this.isLoading = false))
    },
    onExport() {
      const sortField = this.options.sortField
      const sortOrder = this.options.sortOrder
      const filters = this.options.filters
      this.isLoadingExport = true
      this.obatService
        .exportBatch(sortField, sortOrder, filters)
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'data-batch.xls')
          document.body.appendChild(link)
          link.click()
        })
        .catch((err) => {
          errorHandler(err, 'Export Data Batch', this)
        })
        .finally(() => (this.isLoadingExport = false))
    },
  },
}
</script>
